import { render, staticRenderFns } from "./PlaceAutoEnrollPanel.vue?vue&type=template&id=65bb03c3&scoped=true"
import script from "./PlaceAutoEnrollPanel.vue?vue&type=script&lang=js"
export * from "./PlaceAutoEnrollPanel.vue?vue&type=script&lang=js"
import style0 from "./PlaceAutoEnrollPanel.vue?vue&type=style&index=0&id=65bb03c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bb03c3",
  null
  
)

export default component.exports